export default {
  labelsLoaded (state, labelsLoaded) {
    state.labelsLoaded = labelsLoaded
  },
  setArticles (state, articles) {
    state.articles.push(articles)
  },
  setTags (state, articles) {
    const tagList = articles.map(article => {
      return article.tagList && Object.values(article.tagList).flat()
    })

    const uniqueTagList = tagList
      .flat()
      .filter(Boolean)
      .filter((value, index, self) => index === self.findIndex(t => t.id === value.id))

    state.tagList = uniqueTagList
  },
  setSelectedTag (state, selectedTag) {
    state.selectedTag = selectedTag
  },
  setPromotedArticles (state, promotedArticles) {
    state.promotedArticles = promotedArticles
  },
  setOffset (state, offset) {
    state.filters.offset = offset
  },
  setLoadingArticles (state, status) {
    state.loadingArticles = status
  },
  setTotalPages (state, totalPages) {
    state.totalPages = totalPages
  },
  setIsInitialDataFetched (state, status) {
    state.isInitialDataFetched = status
  }
}
